import { PipeTransform, Pipe } from '@angular/core';
import { IProductResearchTypeMapping } from "./../models/product-research-type-mapping.model";

@Pipe({
    name: 'researchTypeFilter'
})

export class ResearchTypeFilterPipe implements PipeTransform {

    transform(values: IProductResearchTypeMapping[], filterBy: string): IProductResearchTypeMapping[] {

            filterBy = filterBy ? filterBy.toLocaleLowerCase() : '';
            return filterBy ? values.filter((prtm: IProductResearchTypeMapping) =>
                prtm!.researchTypeName!.toLocaleLowerCase()!.indexOf(filterBy) !== -1) : values;
        }

    }